/**
 * Formats a duration from minutes to a human-readable string
 * @param {number} minutes - Duration in minutes
 * @returns {string} Formatted duration (e.g., "5-min", "2-hr")
 */
export const formatDuration = (minutes) => {
  if (minutes < 60) return `${minutes}-min`;
  const hours = minutes / 60;
  return `${hours}-hr`;
};

/**
 * Gets a specific field value from IDF data for a given return period and duration
 * @param {Object} idfData - The IDF data object containing data_points
 * @param {number} returnPeriod - Return period in years
 * @param {number} duration - Duration in minutes
 * @param {string} field - The field name to extract from the data point
 * @returns {string} Formatted value or "—" if not found
 */
export const getRainfallValue = (idfData, returnPeriod, duration, field) => {
  const dataPoint = idfData?.data_points.find(
    (p) => p.return_period_years === returnPeriod && p.duration_minutes === duration
  );
  return dataPoint?.[field] ? Number(dataPoint[field]).toFixed(1) : "—";
};
